import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { constants } from 'src/app/shared/common/contants';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { checkinListDialogData } from '../../user-multi-column-dropdown/user-multi-column-dropdown.component';
import { ActionCheckBox } from 'src/app/shared/common/ActionCheckBox';
import { ReportlinksserviceService } from '../../reportlinks/reportlinksservice.service';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';


import { ManagemdlscriptComponent } from '../managemdlscript.component';
import { ActionMDLCheckbox } from 'src/app/shared/common/ActionCheckboxButton';
import { NgxUiLoaderService } from 'ngx-ui-loader';

export interface multiselectcript {
  edata:any;
  tenantid:any;
}

@Component({
    selector: 'app-multiselectmdlscript',
    templateUrl: './multiselectmdlscript.component.html',
    styleUrls: ['./multiselectmdlscript.component.scss'],
    standalone: false
})
export class MultiselectmdlscriptComponent implements OnInit {
 validations_form: UntypedFormGroup;
 validation_messages
 columnDefs;
 rowClassRules;
 defaultColDef;
 rowSelectionForTablesFields;
 rowSelection;
 
 paginationPageSize;
 
 paginationNumberFormatter;
 
 lastpage;
 
 currentpage;
 
 nextpage;
 
 nextpageplusone;
 
 totalpages;
 getdata 
 buttonIdList: any = [];
 pagesize;
 components: any;
 gridApi;
   buttonColor = "";
   backgroundColorScreen;
   attributesDataList:any=[]
     componentTypeData: any = []
       JsuiteCategoryData: any = []
         propertyData: any;
         params
            gridDataList:any=[];
            editDataList: any[] = [];
            scriptDataList:any=[]

   attributeObject={
     "executionorder":'',
     "propertycategory": '', 
     "propertyname": '', 
     "component_type": '', 
     "isexecutable": true, 
     "createmdltemplate": ''
   }
   onEditButton=true;
   existingDataList=[]
   attributeHeaders=["managemdlscriptId","executionorder","propertycategory","propertyname","component_type", "isexecutable", "createmdltemplate"]
   constructor(
     private validation: validationmethod,
         private localStorageSettings: LocalStorageSettingsService,
         public dialogref: MatDialogRef<MultiselectmdlscriptComponent>,
         @Inject(MAT_DIALOG_DATA) public data:multiselectcript,
         private snackbar: MatSnackBar,private constants: constants,
         private msg: ErrorMessages,private commonService: CommonService,
         private localstorage: LocalStorageSettingsService,
            private spinner: NgxUiLoaderService
         
   ) { 
     this.validation_messages = this.msg.mdlscript;
      this.components = {
           buttonRenderer: ActionMDLCheckbox,
         }
   }
 
   ngOnInit(): void {
     if(this.data.edata){
       console.log(this.data.edata);
       this.existingDataList=JSON.parse(this.data.edata);
       this.scriptDataList= this.existingDataList
     }
     this.columnDefs = [{
       headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
       pinned:'left',
       lockPinned:true,
       cellRendererParams: {
              existingDataList: this.existingDataList,

         edit: this.EditIcon.bind(this),
        onCheckboxChange:this.checkIcon.bind(this)

       }, width: 150
     },
      //  { headerName: 'ID', headerTooltip: 'ID', tooltipValueGetter: (params) => 'ID : ' + params.value, field: 'managemdlscriptId', filter: 'agTextColumnFilter', width: 150 },

       { headerName: 'Property Category', headerTooltip: 'Property Category', tooltipValueGetter: (params) => 'Property Category : ' + params.value, field: 'propertycategory', filter: 'agTextColumnFilter', width: 150 },
       { headerName: 'Property Name', headerTooltip: 'Property Name', tooltipValueGetter: (params) => 'Property Name : ' + params.value, field: 'propertyname', filter: 'agTextColumnFilter', width: 150 },
       { headerName: 'Component Type', headerTooltip: 'Component Type', tooltipValueGetter: (params) => 'Component Type : ' + params.value, field: 'component_type', filter: 'agTextColumnFilter', width: 150 },
       { headerName: 'Is Executable', headerTooltip: 'Is Executable', tooltipValueGetter: (params) => 'Is Executable : ' + params.value, field: 'isexecutable', filter: 'agTextColumnFilter', width: 150 },
       { headerName: 'Execution Order', headerTooltip: 'Execution Order', tooltipValueGetter: (params) => 'Execution Order : ' + params.value, field: 'executionorder', filter: 'agTextColumnFilter', width: 150 },
       { headerName: 'Create Script', headerTooltip: 'Create Script', tooltipValueGetter: (params) => 'Create Script : ' + params.value, field: 'createmdltemplate', filter: 'agTextColumnFilter', width: 150 }

       
     ],
     // if the record has status==no , row color will change
     this.rowClassRules = {
       "sick": function (params) {
         var numSickDays = params.node.data.status;
         return numSickDays === "No" || numSickDays === null;
       },
 
     };
     // below object is resizable, sorting and filter for ag-grid
     this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
       sortable: true,
       resizable: true,
       filter: true
     };
     this.rowSelectionForTablesFields='multiple';
     this.rowSelection = this.constants.rowselection;
     this.paginationPageSize = 5;
     this.paginationNumberFormatter = function (params) {
       return params.value.toLocaleString();
     };
 
     this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
     this.buttonColor = this.localStorageSettings.getSettings("ColorA");
     this.getJsuiteProperty();
    this.retrieveComponentType();
     this.formValidation()
   }
 
   formValidation() {
       
       this.validations_form = new UntypedFormGroup({

         propertycategory: new UntypedFormControl('', [Validators.required]),
              propertyname: new UntypedFormControl('', [Validators.required]),
              component_type: new UntypedFormControl('', [Validators.required]),
              isexecutable: new UntypedFormControl(false),
              createmdltemplate: new UntypedFormControl('', [Validators.required]),
              executionorder: new UntypedFormControl('', [Validators.required])
   
       });
     }
   onBtExport() {
     this.gridApi.api.exportDataAsCsv();
   }
 
   //pagination code
   onPaginationChanged() {
     if (this.gridApi.api) {
       this.lastpage = this.gridApi.api.paginationIsLastPageFound();
       this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1
       this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1
       this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1
       this.totalpages = this.gridApi.api.paginationGetTotalPages()
     }
   }
   //this function is for going to the given page number 
   onSearchChange(searchValue: number) {
 
     this.gridApi.api.paginationGoToPage(searchValue - 1);
   }
 
   // below function is for changing the no of rows per page
   onPageSizeChanged() {
     var value = this.pagesize
     this.gridApi.api.setGridOption('paginationPageSize', Number(value));
   }
 
   // below function is for going to next page
   onBtNext() {
     console.log("next")
     this.gridApi.api.paginationGoToNextPage();
   }
 
   // below function for going to previous page
   onBtPrevious() {
     console.log("previous")
     this.gridApi.api.paginationGoToPreviousPage();
   }
 
   // below function for going to first page
   onBtFirst() {
     console.log("first")
     this.gridApi.api.paginationGoToFirstPage();
   }
 
   // below function for going to last page
   onBtLast() {
     console.log("last")
     this.gridApi.api.paginationGoToLastPage();
   }
   saveAttributes(){
     let attributesData = this.scriptDataList;
 
     let attributesJsonData = attributesData
     
     let attributesStringData = JSON.stringify(attributesJsonData);
     console.log(attributesStringData);
     this.dialogref.close(attributesStringData);
   }
   cancel(){
     this.dialogref.close();


   }
   cancelEdit(){
           this.onEditButton=true;

   }
   editAttribute(data,index){
 
   }
   deleteWhere(index){
 
   }
   EditIcon(e){
         this.onEditButton=false

   console.log(e);
    this.commonService
        .getjsuitePropertyByCategory(e.rowData.propertycategory)
        .subscribe((res: any) => {
          this.propertyData = res;

          console.log('property category:', e.rowData.propertycategory);
          console.log('propertyData:', this.propertyData);
          console.log('propertyname:', e.rowData.propertyname);

          if (e.rowData.propertyname && this.propertyData?.length > 0) {
            const selectedIds = e.rowData.propertyname
              .replace(/\[|\]/g, '')
              .split(',')
              .map(id => Number(id.trim()))
              .filter(id => !isNaN(id));
            console.log(e.rowData.propertyname)
          }
        });

     this.attributeObject={
       propertycategory: e.rowData.propertycategory, 
       propertyname: e.rowData.propertyname, 
       component_type: e.rowData.component_type, 
       isexecutable: e.rowData.isexecutable, 
       executionorder: e.rowData.executionorder, 
       createmdltemplate: e.rowData.createmdltemplate
      
     }
   }
   checkIcon(e){
        console.log(e.rowData)
                 const duplicate = this.existingDataList.some(item =>
         item.propertyname ==e.rowData.propertyname
         
       
      )
           const duplicatescript = this.attributesDataList.some(item =>
         item.propertyname ==e.rowData.propertyname
         
       
       )
       console.log(duplicate)
       if(duplicate && e.checked){
         console.log("Inside duplicate")
         this.snackbar.open("Script already existed","Ok",{duration:5000})
         return
       }

          this.attributeObject={
       propertycategory: e.rowData.propertycategory, 
       propertyname: e.rowData.propertyname, 
       component_type: e.rowData.component_type, 
       isexecutable: e.rowData.isexecutable, 
       executionorder: e.rowData.executionorder, 
       createmdltemplate: e.rowData.createmdltemplate
      
     }
     if(  e.checked){
        this.scriptDataList.push(this.attributeObject)
     }else{
 const index = this.scriptDataList.findIndex(
    item => item.propertyname === this.attributeObject.propertyname
  );

  if (index !== -1) {
    this.scriptDataList.splice(index, 1);
  }     }


   }
   deleteIcon(e){
   console.log(e);
   this.attributesDataList.splice(e.rowData.managemdlscriptId, 1);
   for(let i=0;i<this.attributesDataList.length;i++){
     this.attributesDataList[i].index=i
   }
   this.gridApi.api.setGridOption('rowData', this.attributesDataList)
   }
   onGridReady(params){
        this.retrieve();
     this.gridApi = params;
     params.api.setGridOption('rowData', [])

   }

      retrieve(){
      console.log("inside retrival")
      this.commonService.retrieveManageMdlScript().subscribe(response=>{
      if(response.error == true){
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.getdata = null;
      }else{
        console.log(response)
        this.getdata = response
        console.log(this.getdata)
                this.getdata = response.filter((obj: any) => obj.isexecutable === true)

        for(let i=0;i<this.getdata.length;i++){
      
   this.attributeObject={

       propertycategory: this.getdata[i].propertycategory, 
       propertyname: this.getdata[i].propertyname, 
       component_type: this.getdata[i].component_type, 
       isexecutable: this.getdata[i].isexecutable, 
       executionorder: this.getdata[i].executionorder, 
       createmdltemplate: this.getdata[i].createmdltemplate
      
     } 
                           this.gridDataList.push(this.attributeObject)
    
                          }


         let editDataList: any[] = [];

         if(this.scriptDataList.length>0){


  editDataList = [...this.scriptDataList];
        for (let i = 0; i < this.gridDataList.length; i++) {
  const gridProp = this.gridDataList[i].propertyname;

  const exists = this.scriptDataList.some(
    attr => attr.propertyname === gridProp
  );

  if (!exists) {
      editDataList.push({ ...this.gridDataList[i] }); // optional deep copy
  }
}
        this.gridApi.api.setGridOption('rowData', editDataList)

      }else{
        this.gridApi.api.setGridOption('rowData', this.gridDataList)}
        console.log(editDataList)

       // }
      }
     
      })
    }
 
   addWhere(){
     console.log(this.attributeObject);
     this.spinner.start();
     
     if (!this.validations_form.valid) {
 
       // displaying validation messages
       this.validation.validateAllFormFields(this.validations_form);
 
       this.validation.getvalidationmessage();
            this.spinner.stop();

 
     } else {
       const duplicate = this.attributesDataList.some(item =>
         item.label ==this.attributeObject.propertyname
       
       )
       console.log(duplicate)
       if(duplicate){
         console.log("Inside duplicate")
         this.snackbar.open("Attribute already existed","Ok",{duration:5000})
              this.spinner.stop();

         return
       }
       if(!this.onEditButton){
        const index1 = this.scriptDataList.findIndex(
    item => item.propertyname === this.attributeObject.propertyname
  );

  if (index1 !== -1) {
    this.scriptDataList.splice(index1, 1);
  } 
        let index
                 let editDataList: any[] = [];


        for(let i=0;i<this.gridDataList.length;i++){
          if(this.gridDataList[i].propertyname==this.attributeObject.propertyname)
            index=i;
          //  if(this.attributesDataList.length!=this.gridDataList.length){
          //                   for(let k=0;k<this.gridDataList.length;k++){
          //                     if(!this.gridDataList.contain(this.attributesDataList[i].propertyname)){

          //                     }


                    
          //         }
          //       }

        }
        console.log(index)
  editDataList = [...this.attributesDataList];
        for (let i = 0; i < this.gridDataList.length; i++) {
  const gridProp = this.gridDataList[i].propertyname;

  const exists = this.attributesDataList.some(
    attr => attr.propertyname === gridProp
  );

  if (!exists) {
      editDataList.push({ ...this.gridDataList[i] }); // optional deep copy
  }
}
   
         this.attributesDataList[index]=this.attributeObject//need to check
                  editDataList[index]=this.attributeObject
                  let updateData={"propertycategory": '', 
     "propertyname": '', 
          "propertyvalue": '', 
          tenantid:0


                  }
                  const match = this.attributeObject.createmdltemplate.match(/label\(\s*'([^']+)'\s*\)/);

const labelValue = match ? match[1] : null;

console.log(labelValue);
if(labelValue!='{propertyvalue}'){
                  updateData.propertyname=this.attributeObject.propertyname
                  updateData.propertycategory=this.attributeObject.propertycategory
                  updateData.tenantid=this.data.tenantid
                  updateData.propertyvalue=labelValue
                  this.updateJsuiteProperties(updateData)
                }

        // console.log(this.attributesDataList[this.attributeObject.propertyname]);
        //  this.attributesDataList[this.attributeObject.propertyname]=this.attributeObject
                  // this.attributesDataList.push(this.attributeObject)
                 

         this.gridApi.api.setGridOption('rowData', editDataList)
              this.spinner.stop();
                       this.snackbar.open("Successfully record is updated.","Ok",{duration:5000})



       }else{
        //  this.attributesDataList.push(this.attributeObject)
        //  this.gridApi.api.setGridOption('rowData', this.attributesDataList)
       }
        this.attributeObject={
        // managemdlscriptId:0,
     "executionorder":'',
     "propertycategory": '', 
     "propertyname": '', 
     "component_type": '', 
     "isexecutable": true, 
     "createmdltemplate": ''
   }
       
    //    this.attributeObject={
    //           managemdlscriptId:null,

    //      "executionorder":null,
    //  "propertycategory": null, 
    //  "propertyname": null, 
    //  "component_type": null, 
    //  "isexecutable": false, 
    //  "createmdltemplate": null
    //    }
       this.onEditButton=true;
       this.validations_form.reset();
       this.validations_form.clearValidators();
     }
   }
   /**
    * @Modified by Shyam
    * @param data 
    * @description as discussed with Asha Waghadure, commented th OnFileChange method which is responsible for uploading the excel file, as we are not going with excel upload option in MVP1. This code can be referred in future when we will implement the excel upload functionality.
    */
  //    onFileChange(event: any): void {
  //      console.log(event);
  //      let input = event.target as HTMLInputElement;
  //      const target: DataTransfer = <DataTransfer>event.target;
       
  //      if (target.files.length !== 1) {
  //        console.error('Cannot use multiple files');
  //        return;
  //      }
   
  //      const reader: FileReader = new FileReader();
  //      reader.onload = (e: any) => {
  //        const binaryData = e.target.result;
  //        const workbook: XLSX.WorkBook = XLSX.read(binaryData, { type: 'binary' });
   
  //        // Read the first sheet
  //        const sheetName: string = workbook.SheetNames[0];
  //        const sheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
   
  //        // Convert to JSON
  //        const jsonData:any = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  //  console.log(jsonData);
   
  //        if (jsonData.length > 0) {
  //          let headerList=[]
  //          headerList=jsonData[0]
  //          let labelsToRemove = this.attributeHeaders.map(obj => obj);
  //          headerList =  jsonData[0].filter(item => !labelsToRemove.includes(item));
  //          if(headerList.length == 0){
  //            let data = jsonData.slice(1).map((row: any[], i: number) => {
  //              const rowObj: any = { index: this.attributesDataList.length + i }; // Starts from 0
  //              jsonData[0].forEach((key: string, index: number) => {
  //                rowObj[key] = row[index] !== undefined ? row[index] : '';
  //              });
  //              return rowObj;
  //            });
  //            console.log(data);
  //            try {
  //              this.validateExcelData(data);
  //               const uniqueData = data.filter((item,index,self) =>
  //                index === self.findIndex(record=>
  //                  record.name?.trim()===item.name?.trim() && record.label?.trim()===item.label?.trim()
  //                )
  //              )
  //              console.log(uniqueData)
  //              const finalUniqueData = uniqueData.filter(newRecord =>
  //                !this.attributesDataList.some(existingRecord =>
  //                  existingRecord.name?.trim() === newRecord.name?.trim() && existingRecord.label?.trim() === newRecord.label?.trim()
  //                )
  //              )
  //               // this.attributesDataList.push(...finalUniqueData)
  //              //  this.attributesDataList.push(...data)
  //               this.gridApi.api.setGridOption('rowData', this.attributesDataList)
  //            } catch (error) {
  //              console.error(error.message);
  //              // optionally show error in UI
  //              this.snackbar.open(error.message, "OK", { duration: 5000 });
  //            }
            
  //          }else{
  //            alert("The headers appear to be mismatched. Kindly update them to match correctly.")
  //      }
  //        }
  //      };
      
  //      reader.readAsBinaryString(target.files[0]);
  //      input.value = '';
  //    }
 
     validateExcelData(data: any[]): void {
       data.forEach((item, i) => {
         if (!item.name || !item.label) {
           throw new Error(`Name and Label are required fields. Some rows in the uploaded file are missing them.`);
         }
       });
     }
      downloadTemplate() {
        /*
         @modified by Aman Singh
         @date 16-05-2024
         @desc the file name from "CasesForSplitReports.csv" to "ReferenceKeysForSplitReport.csv" and column "CASE NUMBER" to "SOURCE_REFERENCE_KEY"
        */
 
     console.log('working');
     var data = [{
       "name":'',
       "label":'',
       "type":'', 
       "required":'',
        "type_value":'',
         "list_column":'',
          "max_type_value":'', 
       "min_type_value":'',
        "isControlledVocabulary":''
     }];
     this.JSONToCSVConvertor(data, 'AttributeHeadersTemplate', true);
   }
 
   JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
     //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
     var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
 
     var CSV = '';
 
     //This condition will generate the Label/Header
     if (ShowLabel) {
       var row = '';
 
       //This loop will extract the label from 1st index of on array
       for (var index in arrData[0]) {
 
         //Now convert each value to string and comma-seprated
         row += index + ',';
       }
 
       row = row.slice(0, -1);
 
       //append Label row with line break
       CSV += row + '\r\n';
     }
 
     //1st loop is to extract each row
     for (var i = 0; i < arrData.length; i++) {
       var row = '';
 
       //2nd loop will extract each column and convert it in string comma-seprated
       for (var index in arrData[i]) {
         row += '"' + arrData[i][index] + '",';
       }
       //add a line break after each row
       CSV += row + '\r\n';
     }
 
     if (CSV == '') {
       alert('Invalid data');
       return;
     }
 
     //Generate a file name
     var fileName = '';
     //this will remove the blank-spaces from the title and replace it with an underscore
     fileName += ReportTitle.replace(/ /g, '_');
 
     //Initialize file format you want csv or xls
     var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
 
     // Now the little tricky part.
     // you can use either>> window.open(uri);
     // but this will not work in some browsers
     // or you will not get the correct file extension
 
     //this trick will generate a temp <a /> tag
     var link = document.createElement('a');
     link.href = uri;
 
     //set the visibility hidden so it will not effect on your web-layout
     // @ts-ignore
     link.style = 'visibility:hidden';
     link.download = fileName + '.csv';
 
     //this part will append the anchor tag and remove it after automatic click
     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
   }

   getJsuiteProperty() {
    // this.spinner.start();
    this.commonService
      .getjsuiteCategory("Jsuite Property Category")
      .subscribe({
        next: (res) => {
          console.log(res)
          this.JsuiteCategoryData = res;
          console.log(this.JsuiteCategoryData)
          // this.spinner.stop();
        },
        error: (err) => {
          console.error(err);
          // this.spinner.stop();
        }
      });
  }

  retrieveComponentType() {
    // this.spinner.start();
    const dnsName = this.localstorage.getSettings("vaultDnsname")

    this.commonService
      .getComponentType(dnsName)
      .subscribe({
        next: (res) => {
          console.log(res)
          this.componentTypeData = res;
          console.log(this.componentTypeData)
          // this.spinner.stop();
        },
        error: (err) => {
          console.error(err);
          // this.spinner.stop();
        }
      });
  }
   updateJsuiteProperties(data) {
    // this.spinner.start();
    this.commonService
      .updateJsuiteProperties(data)
      .subscribe({
        next: (res) => {
          console.log(res)
          console.log(res.data)
          // this.spinner.stop();
        },
        error: (err) => {
          console.error(err);
          // this.spinner.stop();
        }
      });
  }

 

}
